module.exports = __webpack_public_path__ + "static/media/n00122.a06512a8.jpg";